module.exports = __webpack_public_path__ + "static/media/suggestedToFriends_250_500.64bcdab8.png";